// extracted by mini-css-extract-plugin
export default {"position-list":"SearchPosition_position-list__BxClg","position":"SearchPosition_position__D9E04","label":"SearchPosition_label__feRvW"};